// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8d5b9c74","64":"e137f35e","115":"9a44af42","235":"8666dd14","441":"9e52894f","453":"cd38593a"}[chunkId] + ".chunk.js";
};